export default "__VITE_ASSET__yD36scvr__"